import React, { useState } from 'react';
import DataAid from '../constants/data-aids';
import { UX2 } from '@wsb/guac-widget-core';

const styles = {
  description: {
    fontSize: 12,
    textAlign: 'left'
  },
  toggle: {
    color: 'primary',
    textAlign: 'left',
    paddingTop: 'small',
    marginBottom: '10px',
    cursor: 'pointer'
  },
  icon: {
    marginLeft: '5px'
  }
};

const useAccordion = (description, staticContent) => {
  const [open, setOpen] = useState(false);
  const getTCCLString = UX2.utils.TCCLUtils.getTCCLString;

  const onClick = () => {
    setOpen(!open);
  };

  const renderAccordion = () => {
    return description && open ? (
      <UX2.Element.Text
        style={ styles.description }
        data-aid={ DataAid.PODCAST_EPISODE_DESCRIPTION_RENDERED }
        dangerouslySetInnerHTML={{ __html: description }}
      />
    ) : null;
  };

  const renderButton = () => {
    return description ? (
      <UX2.Element.Text
        onClick={ onClick }
        data-aid={ DataAid.PODCAST_TOGGLE_DESCRIPTION_RENDERED }
        data-tccl={ getTCCLString({
          eid: open ? 'ux2.podcast.hide_description.click' : 'ux2.podcast.show_description.click',
          type: 'click'
        }) }
        style={ styles.toggle }
      >
        { `${open ? staticContent.hideDescription : staticContent.showDescription}` }
        <UX2.Element.Icon
          icon={ open ? 'chevronUp' : 'chevronDown' }
          style={ styles.icon }
          size='small'
        />
      </UX2.Element.Text>
    ) : null;
  };

  return {
    Accordion: renderAccordion,
    AccordionButton: renderButton
  };
};

export default useAccordion;
